<template>
    <v-row class="card-container kimsa-elevation">
        <v-col cols="4" class="p-relative">
            <v-img contain :src="require('@/assets/img/user-statistic.png')" class="card-img"/>
        </v-col>
        <v-col cols="8">
            <div class="card-text-primary my-1">
                {{ $t('common.student_statistics') }}
            </div>
            <div class="card-subtext">
                {{ $t('common.student_statistics_subtext') }}
            </div>
        </v-col>
    </v-row>
</template>

<script>

export default {
    name: "StatisticsCard",
}
</script>

<style scoped>

.card-container {
    background-color: #FEFEFE;
    border-radius: 20px;
}

.card-img {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    max-width: 100px;
}

.card-text-primary {
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #161616;
    text-transform: uppercase;
}

.card-subtext {
    font-size: 16px;
    line-height: 19px;
    color: #161616;
}

</style>